module.exports = __webpack_public_path__ + "img/app_ios.9f71543a.png";